export default __webpack_public_path__ + "static/media/night.900d5d9d.svg";